import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import LabelText from "./LabelText";
import Select from '@mui/material/Select';
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import {useObserver} from "mobx-react";
import FormHelperText from "@material-ui/core/FormHelperText";
import {Box} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {ListItemIcon} from "@mui/material";


const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: 0,
        width: '100%'
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    inputSelect:{
        fontSize: '0.813rem',
        ...theme.select,
        minWidth: 200,
        marginRight: 10
    },
    selectPaper: {
        width: 200,
        border: theme.palette.border.secondary,
        boxShadow: theme.palette.shadow.primary,
        ...theme.select,
        '& > :first-child': {
            '& .MuiListItem-root.Mui-disabled': {
                opacity: 1
            },
        }
    },
    titleItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        '& > :nth-child(2)': {
            minWidth: 'auto',
            '& > *': {
                color: theme.palette.primary.main
            }
        }
    },
    allItems: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        '& > :first-child': {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        '& > :nth-child(2)': {
            minWidth: 'auto',
            '& > *': {
                color: "transparent"
            }
        }
    }
}));

export default function InputSelect({
                                        form,
                                        name,
                                        placeholder,
                                        value,
                                        variant,
                                        label,
                                        selectType,
                                        dataList,
                                        dataKey,
                                        dataValue,
                                        isEditable = true,
                                        style,
                                        text,
                                        required
                                    }) {
    const classes = useStyles();
    const {t} = useTranslation();

    const _valueOf = (dataList, data, dataKey, dataValue) => {

        if (data === undefined || data === null) {
            return null;
        }

        let selectKey = "";
        if( dataKey === undefined ){
            Object.keys(dataList).map((key, index) => {
                if (dataList[key] === data) {
                    selectKey =  t('CommonCode.' + dataList[key]);
                }
            });
        } else {
            Object.keys(dataList).map((key, index) => {
                if (dataList[key][dataValue] === data) {
                    selectKey =  dataList[key][dataKey];
                }
            });
        }
        return selectKey;
    }

    const field = form.$(name);

    let defaultSelectKey = '';

    if ( text !== undefined ) {
        defaultSelectKey = text;
    } else {
        if (value !== undefined) {
            if (selectType !== undefined) {
                defaultSelectKey = _valueOf(selectType, value);
            } else if (dataList !== undefined) {
                defaultSelectKey = _valueOf(dataList, value, dataKey, dataValue);
            }
        }
    }

    const onChangeSelectEvent = (event) => {
        defaultSelectKey = event.target.value;
        field.value = defaultSelectKey;
    };

    const SelectList = () => {
        if (selectType !== undefined) {
            return (
                <React.Fragment>
                    <Select
                        displayEmpty={false}
                        onChange={onChangeSelectEvent}
                        defaultValue={value===undefined || value==='' ? "NONE" : value}
                        className={`${classes.inputSelect} ${style?style:null}`}
                        IconComponent={ExpandMoreIcon}
                        MenuProps={{
                            classes: {paper: classes.selectPaper},
                            anchorOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            }
                        }}
                    >
                        <MenuItem value="NONE" key="none" disabled={required!==undefined?required:true}>
                            <Box className={classes.titleItem}>
                                <div>{placeholder}</div>
                                <ListItemIcon>
                                    <ExpandMoreIcon/>
                                </ListItemIcon>
                            </Box>
                        </MenuItem>

                        {Object.keys(selectType).map((key, index) => (
                            <MenuItem key={index} value={selectType[key]} name={name}>
                                <Box className={classes.allItems}>
                                    <div>{selectType.getText(selectType[key])}</div>
                                    <ListItemIcon>
                                        <ExpandMoreIcon/>
                                    </ListItemIcon>
                                </Box>
                            </MenuItem>
                        ))}
                    </Select>
                </React.Fragment>
            )
        } else if (dataList !== undefined && dataList.length > 0) {
            return (
                <React.Fragment>
                    <Select
                        displayEmpty={false}
                        onChange={onChangeSelectEvent}
                        defaultValue={value===undefined || value==='' ? "NONE" : value}
                        className={`${classes.inputSelect} ${style?style:null}`}
                        IconComponent={ExpandMoreIcon}
                        MenuProps={{
                            classes: {paper: classes.selectPaper},
                            anchorOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            }
                        }}
                    >
                        <MenuItem value="NONE" key="none" disabled={required!==undefined?required:true}>
                            <Box className={classes.titleItem}>
                                <div>{placeholder}</div>
                                <ListItemIcon>
                                    <ExpandMoreIcon/>
                                </ListItemIcon>
                            </Box>
                        </MenuItem>

                        {Object.keys(dataList).map((key, index) => (
                            <MenuItem key={index} value={dataList[key][dataValue]} name={key}>
                                <Box className={classes.allItems}>
                                    <div>{dataList[key][dataKey]}</div>
                                    <ListItemIcon>
                                        <ExpandMoreIcon/>
                                    </ListItemIcon>
                                </Box>
                            </MenuItem>
                        ))}
                    </Select>
                </React.Fragment>
            )
        } else {
            return (
                "-"
            )
        }
    }
    return useObserver( () => (
        <React.Fragment>
            {
                isEditable
                ?
                (
                    <FormControl variant="outlined" className={classes.formControl} {...(field?.error ? {error: true} : null)}>
                        <SelectList/>
                        {field ? <FormHelperText>{field.error ? field.error : " "} </FormHelperText> : null }
                    </FormControl>
                )
                :
                (
                    <LabelText translation={false} label={defaultSelectKey}/>
                )
            }
        </React.Fragment>
    ));
}

